import { Box } from '@truepill/react-capsule'
import { UserRoles } from '@truepill/tpos-types'
import AuthLimited from 'components/AuthLimited'
import type { SideToolBarProps } from 'types'
import {
  AnnotationsButton,
  AttachmentsButton,
  ClinicalHistoryButton,
  DispensingLogicButton,
  DurButton,
  FillHistoryButton,
  LogButton,
  MedicationHistoryButton,
  NotesButton,
  OrderDetailsButton,
  PharmacyTransferButton,
} from './components'

export const SideToolBar = ({ logs, fill, order, prescription, patient, showNotesBadge, docs }: SideToolBarProps) => {
  return (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '12px',
      }}
    >
      <DurButton fill={fill} />

      <PharmacyTransferButton />

      <ClinicalHistoryButton />

      <AnnotationsButton />

      <FillHistoryButton />

      <MedicationHistoryButton patientId={patient?._id} fillId={fill?._id} />

      <NotesButton showNotesBadge={showNotesBadge} />

      <OrderDetailsButton order={order} />

      <AttachmentsButton docs={docs} />

      <LogButton
        logs={logs}
        fillId={fill?._id}
        orderId={order?._id}
        prescriptionId={prescription?._id}
        patientId={patient?._id}
      />

      <AuthLimited roles={[UserRoles.Admin]}>
        <DispensingLogicButton prescription={prescription} fillId={fill?._id} />
      </AuthLimited>
    </Box>
  )
}
